export { CTAColors, alertColors, neutralColors } from '../../colors/colors.js';

var brandColors = {
  primary: "#f16421",
  secondary: "#293F4D"
};

export { brandColors };
